import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  order?: { ref_spec: string };
};

const RefSpecCell = React.memo((row: KpiWorkunitGridData) => (
  <>
    {row?.order?.ref_spec && (
      <Tooltip title={row.order.ref_spec}>
        <Typography variant="body2" noWrap>
          {row.order.ref_spec}
        </Typography>
      </Tooltip>
    )}
  </>
));

export default RefSpecCell;
